import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonCheckbox from "../ButtonCheckbox";

/**
 * headerGroups (opcional): linha extra acima do cabeçalho, para agrupar colunas
 * relacionadas — cada item é `{label, colSpan, className}`. Quando não é
 * passada, o cabeçalho segue com uma única linha.
 */
export const Table = ({header, headerGroups, rows, loading, checks, selectedIds, setSelectedIds, sortOrdenationAction, totalCount, onSelectAllResults}) => {
    const navigate = useNavigate();

    const [allIsChecked, setAllIsChecked] = useState(false);
    const [isSelectDropdownOpen, setIsSelectDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if(rows?.length && rows.length > 0 && checks === true){
            getAllIsChecked();
        }
    }, [rows, selectedIds]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsSelectDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleOnClick = (event, row) => {
        if(row.action){
            row.action();
            return;
        }

        if(row.to){
            if(typeof row.beforeNavigate === 'function'){
                row.beforeNavigate();
            }

            if (
                event.ctrlKey ||
                event.shiftKey ||
                event.metaKey || // apple
                (event.button && event.button == 1) // middle click, >IE9 + everyone else
            ){
                window.open(row.to);
            } else {
                navigate(row.to, { state: row.state });
            }
        }
    }

    const handleSelectId = id => {
        let toSelectedIds = [...selectedIds];
        if(selectedIds.includes(id)){
            toSelectedIds = selectedIds.filter(selectedId => selectedId !== id);
        } else {
            toSelectedIds.push(id);
        }

        setSelectedIds(toSelectedIds);
    }

    const handleSelectAllIds = () => {
        let toSelectedIds = [...selectedIds];

        if(allIsChecked){
            toSelectedIds = [];
        } else {
            rows.map(row => {
                if(row.id !== null && row.id !== undefined && !toSelectedIds.includes(row.id)){
                    toSelectedIds.push(row.id);
                }
            });
        }

        setSelectedIds(toSelectedIds);
    }

    const getAllIsChecked = () => {
        // Linha sem id não é selecionável e não conta para o "todos marcados".
        const selectableRows = rows.filter(row => row.id !== null && row.id !== undefined);
        let toAllIsChecked = selectableRows.length > 0;
        selectableRows.map(row => {
            if(!selectedIds.includes(row.id)){
                toAllIsChecked = false;
            }
        });

        setAllIsChecked(toAllIsChecked);
    }

    const handleHeaderCheckboxClick = () => {
        if (onSelectAllResults) {
            setIsSelectDropdownOpen(prev => !prev);
        } else {
            handleSelectAllIds();
        }
    };

    const handleSelectPage = () => {
        handleSelectAllIds();
        setIsSelectDropdownOpen(false);
    };

    const handleSelectAll = () => {
        if (onSelectAllResults) onSelectAllResults();
        setIsSelectDropdownOpen(false);
    };

    return (
        <div className="table-responsive">
            <table className="table">
                <thead>
                    {headerGroups &&
                        <tr className="table-header-groups">
                            {checks &&
                                <th />
                            }
                            {headerGroups.map((group, index) => (
                                <th key={index} colSpan={group.colSpan ?? 1} className={group.className ?? ''}>
                                    {group.label}
                                </th>
                            ))}
                        </tr>
                    }
                    <tr>
                        {checks &&
                            <th className="table-select-header" style={{ width: 35 }}>
                                <div className="table-select-cell" ref={dropdownRef}>
                                    <ButtonCheckbox
                                        checked={allIsChecked}
                                        onClick={handleHeaderCheckboxClick}
                                    />
                                    {onSelectAllResults && isSelectDropdownOpen && (
                                        <div className="checkbox-select-dropdown">
                                            <button className="checkbox-select-dropdown-item" onClick={handleSelectPage}>
                                                Selecionar todos da página ({rows.length} {rows.length === 1 ? 'item' : 'itens'})
                                            </button>
                                            <button className="checkbox-select-dropdown-item" onClick={handleSelectAll}>
                                                Selecionar todos os resultados ({totalCount} {totalCount === 1 ? 'item' : 'itens'})
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </th>
                        }
                        {header.map((item, index) => (
                            <th key={index}>
                                    {(sortOrdenationAction && sortOrdenationAction(item)) ?? item}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {!loading && rows && rows.map((row, index) => (
                        <tr key={index}>
                            {checks &&
                                <td>
                                    {row.id !== null &&
                                        <ButtonCheckbox
                                        checked={selectedIds.includes(row.id)}
                                        onClick={() => handleSelectId(row.id)}
                                        />
                                    }
                                </td>
                            }
                            {row.data.map((item, index) => (
                                <td key={index} onClick={e => handleOnClick(e, row)} className={`${row.to || row.action? 'has-link' : ''} ${row?.disable === true ? 'tr-disable' : ''} ${row?.className || ''}`}>{item}</td>
                            ))}
                            {row.buttons && row.buttons.map((button, index) => (
                                <td className="td-btn" key={index}>{button}</td>
                            ))}
                        </tr>
                    ))}
                    {!loading && rows && rows.length === 0 &&
                        <tr>
                            <td colSpan={header.length} className="no-data">Nenhum resultado encontrado</td>
                        </tr>
                    }
                    {loading &&
                        <tr>
                            <td colSpan={header.length} className="no-data">Carregando...</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}

export default Table;
